import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

const ArticleCard = ({ article }: ArticleCardProps) => {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block cursor-pointer">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {article.featured && (
            <span className="absolute top-3 left-3 px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
              精选
            </span>
          )}
        </div>
        <div className="p-4">
          <div className="flex items-center gap-3 mb-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.views.toLocaleString()}
            </span>
          </div>
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-100">
            <span className="text-xs text-foreground-500">{article.author}</span>
            <span className="text-xs text-foreground-400">{article.readTime}</span>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default ArticleCard;